import {jsonMember, jsonObject} from "typedjson";

/** Финансирование по годам */
@jsonObject
export class PitActivityFinancingAmount {

  /** Год финансирования */
  @jsonMember({name: "year", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _year: number;

  /** Идентификатор уровня бюджета: федеральный\региональный */
  @jsonMember({name: "budgetLevelId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _budgetLevelId: number;

  /** Сумма финансирования */
  @jsonMember({name: "financingSum", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _financingSum: number;

  /** тип нормирования 1 - норматив, 2 - сверхнорматив, 3 - субсидия */
  @jsonMember({name: "normTypeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _normTypeId: number;


  get year(): number {
    return this._year;
  }

  set year(value: number) {
    this._year = value;
  }

  get budgetLevelId(): number {
    return this._budgetLevelId;
  }

  set budgetLevelId(value: number) {
    this._budgetLevelId = value;
  }

  get financingSum(): number {
    return this._financingSum;
  }

  set financingSum(value: number) {
    this._financingSum = value;
  }

  get normTypeId(): number {
    return this._normTypeId;
  }

  set normTypeId(value: number) {
    this._normTypeId = value;
  }
}
